import { render, staticRenderFns } from "./ResourceButton.vue?vue&type=template&id=2ab1addb&scoped=true&"
import script from "./ResourceButton.vue?vue&type=script&lang=js&"
export * from "./ResourceButton.vue?vue&type=script&lang=js&"
import style0 from "./ResourceButton.vue?vue&type=style&index=0&id=2ab1addb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1addb",
  null
  
)

export default component.exports